import { useState, useContext, createContext } from "react";
import { VerticalTemplates } from "../services/Templates";

const EditCtaContext = createContext(undefined);

export function useEditCtaContext() {
  const ctx = useContext(EditCtaContext);
  if (!ctx)
    throw new Error("useEditCtaContext must be used within EditCtaProvider");
  return ctx;
}

export function EditCtaProvider({ children }) {
  // Existing state for widget functionality
  const [formData, setFormData] = useState({});
  const [formSteps, setFormSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState("");
  const [selectedTemplateKey, setSelectedTemplateKey] = useState("");
  const [presetEditId, setPresetEditId] = useState(null);

  const onNext = () => {
    const stepsLength = VerticalTemplates[selectedTemplateKey].steps.length;
    const currentStepIndex =
      VerticalTemplates[selectedTemplateKey].steps.indexOf(currentStep);

    if (currentStepIndex + 1 < stepsLength) {
      setCurrentStep(
        VerticalTemplates[selectedTemplateKey].steps[currentStepIndex + 1]
      );
    }
  };

  const getCurrentStep = () => {
    return VerticalTemplates[selectedTemplateKey].steps.indexOf(currentStep);
  };

  const onBack = () => {
    const currentStepIndex = getCurrentStep();

    if (currentStepIndex > 0) {
      setCurrentStep(
        VerticalTemplates[selectedTemplateKey].steps[currentStepIndex - 1]
      );
    }
  };

  const explicitBoleanCheck = (vars) => {
    // Strict checks per spec: true or "true" => true; false or "false" => false
    if (vars === true || vars === "true") return true;
    if (vars === false || vars === "false") return false;

    // Fallback: treat anything else as false to avoid accidental truthiness (e.g., "false" already handled)
    return false;
  };

  const contextValue = {
    formData,
    setFormData,
    formSteps,
    setFormSteps,
    currentStep,
    setCurrentStep,
    onNext,
    onBack,
    selectedTemplateKey,
    setSelectedTemplateKey,
    presetEditId,
    setPresetEditId,
    getCurrentStep,
    explicitBoleanCheck,
  };

  return (
    <EditCtaContext.Provider value={contextValue}>
      {children}
    </EditCtaContext.Provider>
  );
}
